// @flow
export const SAVE_GROUP = 'hive/groups/SAVE_GROUP';
export const SAVE_GROUP_PENDING = 'hive/groups/SAVE_GROUP_PENDING';
export const SAVE_GROUP_COMPLETE = 'hive/groups/SAVE_GROUP_COMPLETE';
export const SAVE_NEW_GROUP_COMPLETE = 'hive/groups/SAVE_NEW_GROUP_COMPLETE';



// WEBPACK FOOTER //
// ./src/core/state/groups/constants.js